import {
  Button,
  Grid,
  IconPlus,
  IconShoppingCartSimple,
  IconTrash,
  Text,
} from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import { NumberInput } from 'ui'
import {
  ProgressiveDiscountBenefit,
  ProgressiveDiscountConfig,
} from '../../../../../../typings'
import messages from '../messages'
import styles from '../styles'

type Props = {
  name: string
  form: FormState
}

export const EMPTY_DISCOUNT: Nullable<ProgressiveDiscountConfig> =
  Object.freeze({
    quantity: undefined,
    discount: undefined,
  })

export function EditorBenefit(props: Props) {
  const { name, form } = props

  const { $t } = useIntl()

  const benefit: ProgressiveDiscountBenefit = useWatch({ form, name })

  const addDiscount = () => {
    form.setValue(name, [
      ...benefit,
      {
        ...EMPTY_DISCOUNT,
      },
    ])
  }

  const removeDiscount = (index: number) => {
    form.setValue(
      name,
      benefit.filter((_, i) => i !== index)
    )
  }

  const hideAddButton =
    benefit.length >= LIMITS.MAX_PROGRESSIVE_DISCOUNT_BENEFIT

  const hideRemoveButton = benefit.length === 1

  useEffect(() => {
    const index = benefit.length - 1
    const nextInputName = `${name}.${index}.quantity`
    document.getElementsByName(nextInputName)[0]?.focus()
  }, [benefit.length, name])

  return (
    <Grid
      templateColumns={hideRemoveButton ? '1fr 1fr' : '1fr 1fr auto'}
      className={styles.grid}
    >
      {benefit.map((_, index) => (
        <>
          <NumberInput
            name={`${name}.${index}.quantity`}
            state={form}
            label={$t(messages.benefit.quantity)}
            suffix={<IconShoppingCartSimple size="small" />}
            min={1}
          />
          <NumberInput
            name={`${name}.${index}.discount`}
            state={form}
            label={$t(messages.benefit.discount)}
            suffix="%"
            min={0}
            max={100}
          />
          <Button
            size="large"
            icon={<IconTrash />}
            hidden={hideRemoveButton}
            variant="neutralTertiary"
            onClick={() => removeDiscount(index)}
            className={styles.removeButton}
            aria-label={$t(messages.benefit.remove)}
          />
        </>
      ))}
      <div>
        <Button
          hidden={hideAddButton}
          icon={<IconPlus />}
          variant="neutralTertiary"
          onClick={addDiscount}
        >
          {$t(messages.benefit.add)}
        </Button>
      </div>
      <Text className={styles.counter} variant="body" tone="secondary">
        {$t(messages.benefit.count, {
          count: benefit.length,
          max: LIMITS.MAX_PROGRESSIVE_DISCOUNT_BENEFIT,
        })}
      </Text>
    </Grid>
  )
}
